
import React from "react";
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";

const PermissionTableHeader: React.FC = () => {
  return (
    <TableHeader>
      <TableRow>
        <TableHead className="w-[250px]">Module</TableHead>
        <TableHead className="text-center">Bekijken</TableHead>
        <TableHead className="text-center">Bewerken</TableHead>
        <TableHead className="text-center">Verwijderen</TableHead>
      </TableRow>
    </TableHeader>
  );
};

export default PermissionTableHeader;
